const mainSearchForm = {
  flights: "Voos", // translated
  tours: "Passeios", // translated
  hotel: "Hotel", // translated
  hotels: "Hotéis", // translated
  services: "Serviços", // translated
  search: "PROCURAR", // translated
  destination: "Destino", // translated
  includedServices: "Serviços incluídos", // translated
  packageDuration: "Duração do pacote", // translated
  checkInOut: "Check-in/out", // translated
  guests: "Convidados", // translated
  adults: "Adultos", // translated
  children: "Crianças", // translated
  child: "Criança", // translated
  age: "Idade", // translated
  yearsOld: "Anos", // translated
  rooms: "quartos", // translated
  close: "Perto", // translated
  searchType: "Tipo de pesquisa", // translated
  accommodation: "Alojamento", // translated
  transfers: "Transferências", // translated
  toursExperiences: "Passeios/Experiências", // translated
  nights: "Noites", // translated
  days: "Dias", // translated
  packageType: "Tipo de pacote", // translated
  tourType: "Tipo de passeio", // translated
  packages: "Pacotes", // translated
  cars: "Carros", // translated
  cruises: "Cruzeiros", // translated
  dream_packages: "Pacotes de sonho", // translated
  origin: "Origem", // translated
  thingsToDo: "Coisas para fazer", // translated
  roundTrip: "Ida e volta", // translated
  airport: "Aeroporto", // translated
  infantsInSeat: "Bebês no assento", // translated
  departureReturn: "Datas de partida e retorno", // translated
  isRoundTrip: "É ida e volta", // translated
  infantsOnLap: "Bebês no colo", // translated
  passengers: "Passageiros", // translated
  partying: "Festa", // translated
};

export default mainSearchForm;
